document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll("li.faq-item");

  items.forEach((item) => {
    item.addEventListener("click", () => {
      const preItemSelected = document.querySelector(".item-selected");
      if (preItemSelected) preItemSelected.classList.remove("item-selected");

      const preContentSelected = document.querySelector(".faq-fade-in");
      if (preContentSelected)
        preContentSelected.classList.replace("faq-fade-in", "faq-fade-off");

      item.classList.add("item-selected");
      const newContent = document.getElementById(item.dataset.target);
      if (newContent)
        newContent.classList.replace("faq-fade-off", "faq-fade-in");
    });
  });
});
